import React, { useState } from "react";
import "./style.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import ComponenteLogin from "../components/ComponenteLogin/index.";

const LoginMobile = ({ setAuthenticated }) => {
    return (
        <div className="login-mobile-tela">
            <div className="login-mobile-componente">
                <ComponenteLogin setAuthenticated={setAuthenticated} />
            </div>
        </div>
    );
};

export default LoginMobile;
